{
    "CX_Score_Licences_None": "Nenhum",
    "CX_Score_Licences_CXSScore": "Pontuação CX apenas",
    "CX_Score_Licences_CXSAgent": "Agente CXS",
    "CX_Score_Licences_CXSManager": "Gerente de CXS",
    "CX_Score_Agent_Error": "É necessário um agente para uma assinatura {}",
    "NAME": "CXScoreLanguage"
}